import { Action, createAction, props } from '@ngrx/store';

export const UpdateUserSession = createAction('[User] Session Updated', props<{ payload:any }>());

export const USERSESSION = 'userSession';
